const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHipercard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "769px",
    height: "505px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.947
    },
    fill: "#8f8f8f",
    d: "M 43.5,-0.5 C 270.833,-0.5 498.167,-0.5 725.5,-0.5C 749.039,2.37368 763.373,15.3737 768.5,38.5C 768.5,181.167 768.5,323.833 768.5,466.5C 763.712,485.956 751.712,498.623 732.5,504.5C 500.167,504.5 267.833,504.5 35.5,504.5C 16.2923,498.626 4.29227,485.96 -0.5,466.5C -0.5,323.833 -0.5,181.167 -0.5,38.5C 5.39996,15.5996 20.0666,2.59959 43.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 40.5,7.5 C 269.5,7.33333 498.5,7.5 727.5,8C 744.346,11.1784 755.18,21.0117 760,37.5C 760.667,180.167 760.667,322.833 760,465.5C 756.202,482.631 745.702,493.131 728.5,497C 498.833,497.667 269.167,497.667 39.5,497C 22.3244,493.158 11.8244,482.658 8,465.5C 7.33333,322.833 7.33333,180.167 8,37.5C 13.0031,20.9904 23.8365,10.9904 40.5,7.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#961b1e",
    d: "M 165.5,113.5 C 344.5,113.5 523.5,113.5 702.5,113.5C 687.009,195.77 670.175,277.77 652,359.5C 646.278,372.887 636.445,381.721 622.5,386C 613.043,388.854 603.376,390.521 593.5,391C 417.166,391.833 240.832,391.667 64.5,390.5C 80.8858,309.071 97.7192,227.737 115,146.5C 120.957,133.21 130.791,124.044 144.5,119C 151.585,116.958 158.585,115.124 165.5,113.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c9898b",
    d: "M 634.5,196.5 C 638.97,195.514 643.637,195.181 648.5,195.5C 648.784,197.415 648.451,199.081 647.5,200.5C 647.5,199.167 647.5,197.833 647.5,196.5C 643.167,196.5 638.833,196.5 634.5,196.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcf9f9",
    d: "M 634.5,196.5 C 638.833,196.5 643.167,196.5 647.5,196.5C 647.5,197.833 647.5,199.167 647.5,200.5C 643.25,221.744 639.417,243.077 636,264.5C 634.181,273.748 633.347,283.081 633.5,292.5C 629.167,292.5 624.833,292.5 620.5,292.5C 620.664,289.813 620.497,287.146 620,284.5C 616.386,290.063 611.219,293.23 604.5,294C 581.656,295.82 571.823,285.32 575,262.5C 580.499,231.343 598.666,219.009 629.5,225.5C 631.081,215.678 632.747,206.011 634.5,196.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbf7f7",
    d: "M 229.5,196.5 C 239.507,196.837 242.007,201.504 237,210.5C 226.168,216.857 221.835,213.857 224,201.5C 225.406,199.256 227.239,197.59 229.5,196.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcf9f9",
    d: "M 137.5,197.5 C 142.875,197.172 148.208,197.505 153.5,198.5C 150.288,210.767 148.288,223.1 147.5,235.5C 161.363,236.826 175.196,236.826 189,235.5C 191.4,222.866 193.567,210.2 195.5,197.5C 200.833,197.5 206.167,197.5 211.5,197.5C 205.609,229.071 200.276,260.738 195.5,292.5C 190.167,292.5 184.833,292.5 179.5,292.5C 181.198,276.645 183.865,260.979 187.5,245.5C 173.167,245.5 158.833,245.5 144.5,245.5C 141.625,261.085 139.291,276.752 137.5,292.5C 132.167,292.5 126.833,292.5 121.5,292.5C 126.508,260.784 131.842,229.117 137.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcf8f8",
    d: "M 246.5,225.5 C 250.971,224.911 254.971,225.577 258.5,227.5C 258.369,228.376 258.702,229.043 259.5,229.5C 270.76,222.6 282.426,221.767 294.5,227C 301.916,234.267 304.75,243.1 303,253.5C 301.309,268.391 294.809,280.557 283.5,290C 274.081,294.924 264.415,295.591 254.5,292C 252.622,290.457 251.122,288.624 250,286.5C 247.066,298.335 245.233,310.335 244.5,322.5C 239.5,322.5 234.5,322.5 229.5,322.5C 235.709,290.242 241.376,257.909 246.5,225.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcf9f9",
    d: "M 337.5,223.5 C 347.846,221.986 357.346,223.986 366,229.5C 368.847,232.609 370.014,236.275 369.5,240.5C 369.049,245.869 368.383,251.203 367.5,256.5C 351.758,255.858 336.258,256.525 321,258.5C 317.198,278.026 325.032,286.526 344.5,284C 349.872,282.93 355.205,281.763 360.5,280.5C 360.475,283.96 359.808,287.294 358.5,290.5C 354.981,291.932 351.314,292.766 347.5,293C 309.018,297.151 296.851,280.984 311,244.5C 316.47,233.191 325.303,226.191 337.5,223.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcf9f9",
    d: "M 382.5,225.5 C 386.971,224.911 390.971,225.577 394.5,227.5C 393.833,229.819 393.666,232.153 394,234.5C 400.032,224.901 408.532,221.568 419.5,224.5C 418.833,227.833 418.167,231.167 417.5,234.5C 407.191,232.243 399.357,235.576 394,244.5C 388.589,260.018 385.756,276.018 385.5,292.5C 380.833,292.5 376.167,292.5 371.5,292.5C 375.06,270.143 378.726,247.809 382.5,225.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfafa",
    d: "M 442.5,223.5 C 451.524,223.358 460.524,223.692 469.5,224.5C 468.886,228.135 468.552,231.802 468.5,235.5C 462.452,234.02 456.286,233.02 450,232.5C 441.554,232.555 435.221,236.222 431,243.5C 425.136,254.808 424.136,266.474 428,278.5C 431.638,282.826 436.305,284.826 442,284.5C 447.665,283.89 453.165,282.557 458.5,280.5C 460.782,288.43 457.782,292.597 449.5,293C 417.883,297.968 405.716,284.802 413,253.5C 416.853,237.349 426.686,227.349 442.5,223.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcf9f9",
    d: "M 494.5,223.5 C 503.235,223.124 511.902,223.624 520.5,225C 529.889,228.28 533.056,234.78 530,244.5C 526.42,260.312 524.253,276.312 523.5,292.5C 519.167,292.5 514.833,292.5 510.5,292.5C 513.158,282.628 511.491,281.462 505.5,289C 494.578,295.757 483.578,296.09 472.5,290C 465.062,277.919 466.062,266.586 475.5,256C 479.221,253.473 483.221,251.473 487.5,250C 496.812,249.016 506.146,248.182 515.5,247.5C 518.913,241.92 517.913,237.42 512.5,234C 509.07,233.044 505.57,232.544 502,232.5C 495.204,233.692 488.371,234.692 481.5,235.5C 482.326,231.864 482.992,228.197 483.5,224.5C 487.371,224.815 491.038,224.482 494.5,223.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbf7f7",
    d: "M 570.5,223.5 C 581.197,221.195 584.864,225.195 581.5,235.5C 571.021,231.787 563.188,234.787 558,244.5C 556.268,248.363 554.934,252.363 554,256.5C 551.833,268.483 550,280.483 548.5,292.5C 543.833,292.5 539.167,292.5 534.5,292.5C 538.549,270.207 542.382,247.874 546,225.5C 550.066,224.536 554.233,224.203 558.5,224.5C 557.737,227.141 557.57,229.808 558,232.5C 561.79,228.862 565.957,225.862 570.5,223.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c78485",
    d: "M 246.5,225.5 C 250.634,224.515 254.968,224.182 259.5,224.5C 259.737,225.791 259.404,226.791 258.5,227.5C 254.971,225.577 250.971,224.911 246.5,225.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c88788",
    d: "M 382.5,225.5 C 386.634,224.515 390.968,224.182 395.5,224.5C 395.737,225.791 395.404,226.791 394.5,227.5C 390.971,225.577 386.971,224.911 382.5,225.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbf7f6",
    d: "M 220.5,224.5 C 225.167,224.5 229.833,224.5 234.5,224.5C 229.968,247.027 226.301,269.693 223.5,292.5C 218.5,292.5 213.5,292.5 208.5,292.5C 212.932,269.91 216.932,247.243 220.5,224.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#971f20",
    d: "M 355.5,247.5 C 344.779,248.142 334.446,247.475 324.5,245.5C 328.872,234.811 336.872,230.644 348.5,233C 355.614,235.722 357.947,240.556 355.5,247.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#961d1f",
    d: "M 608.5,232.5 C 614.931,232.091 621.098,233.091 627,235.5C 626.384,247.342 624.384,259.009 621,270.5C 617.021,281.576 609.188,286.076 597.5,284C 593.51,282.01 591.01,278.843 590,274.5C 588.248,262.589 590.582,251.589 597,241.5C 600.161,237.491 603.994,234.491 608.5,232.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#961d1f",
    d: "M 265.5,233.5 C 271.732,232.939 277.732,233.772 283.5,236C 287.621,239.525 289.288,244.025 288.5,249.5C 288.648,259.54 286.148,268.873 281,277.5C 275.171,283.753 268.005,285.92 259.5,284C 254.176,281.52 251.843,277.354 252.5,271.5C 253.752,260.737 255.586,250.07 258,239.5C 260.114,236.879 262.614,234.879 265.5,233.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b15657",
    d: "M 324.5,245.5 C 334.446,247.475 344.779,248.142 355.5,247.5C 345.013,248.494 334.346,248.828 323.5,248.5C 323.263,247.209 323.596,246.209 324.5,245.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#971f21",
    d: "M 496.5,256.5 C 502.167,256.5 507.833,256.5 513.5,256.5C 513.582,264.01 511.749,271.01 508,277.5C 502.269,282.977 495.436,285.144 487.5,284C 485.714,283.215 484.214,282.049 483,280.5C 479.625,272.211 481.458,265.378 488.5,260C 491.158,258.522 493.825,257.355 496.5,256.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHipercard);
export default __webpack_public_path__ + "static/media/hipercard.95a80f26091981a657a4a9b3410ff840.svg";
export { ForwardRef as ReactComponent };